export default __webpack_public_path__ + "static/media/your-stake.08092f31.png";